module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wx-bind-view login-form"
  }, [_c('h1', [_vm._v("抱歉，该页面功能正在开发中...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-197e7ee8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/session/wxbind.view.vue
// module id = 900
// module chunks = 3